import React, {useState} from 'react';
import Button from '../../../../../shared/components/Button';
import axiosInstance from '../../../../../shared/utils/axios';
import history from '../../../../../history';
import {DescriptiveText, Tile} from '../../../../../shared';
import {calculateNewWindowDimensions, openNewTab} from '../../../../utils/partners';
import Row from '../../../../../shared/components/Row';
import Page from '../../../../../shared/components/Page';

const WealthboxLogin = () => {
  const [processing, setProcessing] = useState(false);
  const email = localStorage.getItem('email');
  const token = localStorage.getItem('token');
  const runAs = localStorage.getItem('runAs');
  const login = () => {
    setProcessing(true);
    axiosInstance.get('/auth/wealthbox', {params: [email, token, runAs]})
      .then(res => {
        const newWindow = calculateNewWindowDimensions(res.data, 'Wealthbox');
        if (window.focus) {
          newWindow.focus();
        }
      });
  };

  return <Page>
    {
      processing
        ? <Tile key='Wealthbox' title='Wealthbox'>
          <DescriptiveText>
            A window to Wealthbox should have opened. If it has not, please check your popup blocker. Once it has been closed after
            authorizing CircleBlack to integrate with Wealthbox, press continue.
          </DescriptiveText>
          <Button importance={'primary'}
                  size={'md'}
                  label={'Continue'}
                  disabled={false}
                  action={() => history.push('/engage/wealthbox')}/>
        </Tile>
        : <Tile key='Wealthbox' title='Wealthbox'>
          <DescriptiveText>
            {/* eslint-disable-next-line react/no-unescaped-entities */}
            Sign in to your Wealthbox account by clicking the "Sign In" button. You just have to sign in once to keep
            CircleBlack and Wealthbox connected.
          </DescriptiveText>
          <DescriptiveText>If you do not have a Wealthbox account, you can sign up for a free trial by clicking the “Free Trial”
            button below. Once you have signed up for Wealthbox, come back here to CircleBlack to single sign on your
            Wealthbox account.
          </DescriptiveText>
          <Row wrap={false}>
            <Button
              importance={'primary'}
              size={'md'}
              label={'Free Trial'}
              disabled={false}
              action={() => openNewTab('https://app.crmworkspace.com/signup')}
            />
            <Button importance={'primary'} size={'md'} label={'Sign In'} disabled={false} action={login}/>
          </Row>
        </Tile>
    }
  </Page>;
};

export default WealthboxLogin;
